var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3327 17.3327V11.3327C28.3327 9.56457 27.6303 7.86888 26.3801 6.61864C25.1298 5.36839 23.4341 4.66602 21.666 4.66602H10.3327C8.56457 4.66602 6.86888 5.36839 5.61864 6.61864C4.36839 7.86888 3.66602 9.56457 3.66602 11.3327V20.666C3.66602 21.5415 3.83845 22.4084 4.17349 23.2172C4.50852 24.0261 4.99958 24.761 5.61864 25.3801C6.86888 26.6303 8.56457 27.3327 10.3327 27.3327H18.6793",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01172 22.6662L7.66505 18.3995C8.14484 17.923 8.77453 17.6269 9.44756 17.5613C10.1206 17.4957 10.7956 17.6646 11.3584 18.0395C11.9212 18.4144 12.5962 18.5834 13.2692 18.5178C13.9422 18.4522 14.5719 18.156 15.0517 17.6795L18.1584 14.5729C19.051 13.6772 20.2329 13.1278 21.4931 13.0228C22.7533 12.9178 24.0098 13.2639 25.0384 13.9995L28.3317 16.5462M10.6784 13.5595C10.969 13.5578 11.2565 13.4988 11.5244 13.3859C11.7922 13.2731 12.0353 13.1086 12.2395 12.9018C12.4438 12.6951 12.6054 12.4501 12.715 12.1809C12.8246 11.9117 12.8801 11.6235 12.8784 11.3329C12.8766 11.0422 12.8177 10.7547 12.7048 10.4869C12.592 10.219 12.4275 9.97598 12.2207 9.77169C12.0139 9.56741 11.7689 9.40584 11.4997 9.29623C11.2305 9.18662 10.9424 9.1311 10.6517 9.13285C10.0647 9.13639 9.50314 9.37297 9.09056 9.79055C8.67798 10.2081 8.44818 10.7725 8.45172 11.3595C8.45526 11.9465 8.69184 12.5081 9.10942 12.9207C9.527 13.3333 10.0914 13.5631 10.6784 13.5595Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9414 20V26.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9994 22.8052L25.3768 20.1826C25.3198 20.1253 25.252 20.0799 25.1774 20.0489C25.1029 20.0179 25.0229 20.002 24.9421 20.002C24.8613 20.002 24.7813 20.0179 24.7067 20.0489C24.6322 20.0799 24.5644 20.1253 24.5074 20.1826L21.8848 22.8052",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon_upload.07c1c1b091021e66d6fa8107ee0dfad9.svg";
export { ForwardRef as ReactComponent };